
import React, { useEffect, useReducer } from "react";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";

export const Context = React.createContext(null);

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        ...action.payload
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {

  const searchParams = new URLSearchParams(window.location.search);
  const phoneFromQuery = searchParams.get('phone') || '';
  const walletPhoneFromQuery = searchParams.get('showWallet') === '1' ? phoneFromQuery : '';
  var [state, dispatch] = useReducer(reducer, {
    phone: phoneFromQuery,
    keyword: '',
    status: '',
    registeredFrom: null,
    registeredTo: null,
    lastBuyFrom: null,
    lastBuyTo: null
  });

  useEffect(() => {
    document.title = "Khách hàng"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch,
      walletPhoneFromQuery
    }}>

      <FilterForm />

      <br />

      <Table />
    </Context.Provider>
  );
};
